import { Formik, Form } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import Button from 'src/components/button/Button';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TComment, TReplyToCommentRequest } from 'src/services/apiEndpoint.types.ts';
import InputField from 'src/components/common/formFields/inputField/InputField';
import { componentSizeVariantsEnum } from 'src/constants';
import { TUserTypes } from 'src/constants/user.constants';
import { socketService } from 'src/services/socket.api.service';

import './createReply.scss';
import createReplyValidationSchema from './createReply.validationSchema';
import { AnyARecord } from 'node:dns';
import { replyToComment } from 'src/store/venture/venture.slice';
import ExpandableInputField from 'src/components/common/expandableinput/ExpandableInputField';
import { useRef } from 'react';

export type TCreateReply = {
  onClose: () => void;
  ventureVerseId: string;
  comment: any;
  handleGetReplies: () => void;
  viewerId: string;
  viewerType: TUserTypes;
};

export type TReplyTOCommentFormValues = {
  text: string;
};

// This component must know id and type of the viewer
const CreateReply = ({
  onClose,
  ventureVerseId,
  comment,
  handleGetReplies,
  viewerId,
  viewerType
}: TCreateReply) => {
  const initialValues: TReplyTOCommentFormValues = { text: '' };

  const dispatch = useAppDispatch();

  const profile = useAppSelector((store) => store.profile.profile);
  const replyToCommentLoader: boolean = useAppSelector<boolean>(
    (store) => store.venture.replyToCommentLoader
  );
  const { companyProfilePic, myCompany } = useAppSelector((store) => store.company);
  const commentId = comment?.id;
  const replyRef = useRef<any>(null);
  const createReplyProfilePic = viewerType === 'User' ? profile?.profilePic : companyProfilePic;
  const createReplyName = viewerType === 'User' ? profile?.name : myCompany?.name;

  const handleSubmit = async (
    { text }: TReplyTOCommentFormValues,
    { resetForm }: { resetForm: () => void }
  ) => {
    // create reply api call
    console.log('handleSubmit', comment);
    const payload: TReplyToCommentRequest = {
      [viewerType === 'Company' ? 'companyId' : "userId"]: viewerId,
      // replyId: uuidv4(),
      // ventureVerseId,
      content: text,
      commentId
      // userType: viewerType,
      // timestamp: Date.now()
    };

    dispatch(replyToComment(payload)).then(() => {
      if (replyRef.current) {
        replyRef.current.style.height = '42px';
      }
       const performAction = (userId, userType) => {
                        console.log("userId venture", userId);
                              const userIds = [userId];
                              if (viewerId !== comment?.userId) {
                              socketService.emit("notifications-unread", {
                                userIds,
                                userType: userType
                              });
                            }
                            };
                            performAction(comment?.userId, "User");
      resetForm();
    });
  };
  
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={createReplyValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue, values }) => {
          return (
            <Form className="create-reply">
              <div className="create-reply__header">
                <ProfilePicture
                  url={createReplyProfilePic || ''}
                  fallback={createReplyName[0] || ''}
                />
                <ExpandableInputField
                  inputRef={replyRef}
                  variant={componentSizeVariantsEnum.SMALL}
                  id="text"
                  value={values.text}
                  onChange={(e) => {
                    setFieldValue('text', e.target.value);
                  }}
                  placeholder="Reply"
                  isTouched={touched.text}
                  errorMessage={errors.text}
                />
              </div>
              <div className="create-reply__buttons">
                {/* <Button variant="secondary" size="small" onClick={onClose}>
                  Cancel
                </Button> */}
                <Button variant="primary" size="small" type="submit" loading={replyToCommentLoader}>
                  Reply
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateReply;
